import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/logo-white.svg'


const _hoisted_1 = _imports_0 + ' 2x'
const _hoisted_2 = { class: "download-text" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "design-form",
    onSubmit: _withModifiers($setup.handleSubmit, ["prevent"])
  }, [
    _createElementVNode("p", _hoisted_2, _toDisplayString($setup.formTitle), 1),
    _createElementVNode("div", _hoisted_3, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { for: "firstName" }, "FIRST NAME", -1)),
      _withDirectives(_createElementVNode("input", {
        id: "firstName",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.firstName) = $event))
      }, null, 512), [
        [_vModelText, $setup.formData.firstName]
      ]),
      ($setup.v$.firstName.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.v$.firstName.$errors[0]?.$message), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { for: "lastName" }, "LAST NAME", -1)),
      _withDirectives(_createElementVNode("input", {
        id: "lastName",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formData.lastName) = $event))
      }, null, 512), [
        [_vModelText, $setup.formData.lastName]
      ]),
      ($setup.v$.lastName.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.v$.lastName.$errors[0]?.$message), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[6] || (_cache[6] = _createElementVNode("label", { for: "email" }, "EMAIL", -1)),
      _withDirectives(_createElementVNode("input", {
        id: "email",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.email) = $event))
      }, null, 512), [
        [_vModelText, $setup.formData.email]
      ]),
      ($setup.v$.email.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.v$.email.$errors[0]?.$message), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[7] || (_cache[7] = _createElementVNode("label", { for: "phone" }, "PHONE", -1)),
      _createVNode($setup["Cleave"], {
        id: "phone",
        modelValue: $setup.formData.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.phone) = $event)),
        type: "tel",
        class: _normalizeClass({ 'input--error': $setup.v$.phone.$error }),
        options: $setup.phoneNumberOption($setup.formData.phone),
        placeholder: "0412 345 678"
      }, null, 8, ["modelValue", "class", "options"]),
      ($setup.v$.phone.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($setup.v$.phone.$errors[0]?.$message), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("button", {
      class: "submit-button",
      type: "submit"
    }, "Submit", -1)),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "powered-container" }, [
      _createElementVNode("p", null, "Powered by"),
      _createElementVNode("img", {
        src: _imports_0,
        srcset: _hoisted_1,
        alt: "Logo"
      })
    ], -1))
  ], 32))
}